
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'


@Options({
  components: {
    FontAwesomeIcon
  },
})

export default class Webview extends Vue {
  @Prop({ required: false }) title?: string
  @Prop({ required: false }) link?: string
  @Prop() onClose!: () => void

  isReady = false

  onCloseWebview() {
    if (this.onClose) {
      this.onClose()
    }
  }

  created(): void {
    setTimeout(() => {
      this.isReady = true
    }, 300)
  }

}
